<div class="border border-2 border-secondary rounded p-4 p-lg-5 text-center border-secondary-light">
  <ng-content />
</div>
